import { useCallback, useEffect, useRef, useState } from "react";
import { rollerInfo } from "../../../constants/rollet";
import { playAudio } from "../../../constants/Audio";

export const useRouletteSpin = ({ oldResult }) => {
    const [isWin, setIsWin] = useState(false);

    const speed = useRef(0.4);
    const doc = useRef({
        ball: null,
        ballSpin: null,
    });
    const position = useRef(0);
    const targetPositionRef = useRef(0);

    const spinIntervalRef = useRef(null);
    const endRollTimeoutRef = useRef(null);
    const winTimeoutRef = useRef(null);
    const speedDecreaseIntervalRef = useRef(null);
    const rollingStopIntervalRef = useRef(null);

    const clearSpinTimers = useCallback(() => {
        if (spinIntervalRef.current) {
            clearInterval(spinIntervalRef.current);
            spinIntervalRef.current = null;
        }

        if (endRollTimeoutRef.current) {
            clearTimeout(endRollTimeoutRef.current);
            endRollTimeoutRef.current = null;
        }

        if (winTimeoutRef.current) {
            clearTimeout(winTimeoutRef.current);
            winTimeoutRef.current = null;
        }

        if (speedDecreaseIntervalRef.current) {
            clearInterval(speedDecreaseIntervalRef.current);
            speedDecreaseIntervalRef.current = null;
        }

        if (rollingStopIntervalRef.current) {
            clearInterval(rollingStopIntervalRef.current);
            rollingStopIntervalRef.current = null;
        }
    }, []);

    const spin = useCallback((spinSpeed = 2) => {
        if (!doc.current?.ball || !doc.current?.ballSpin) return;

        position.current = (position.current + spinSpeed) % 360;
        doc.current.ball.style.display = "block";
        doc.current.ballSpin.style.transform = `rotate(${position.current}deg)`;
    }, []);

    const setIntSpin = useCallback(() => {
        if (spinIntervalRef.current) {
            clearInterval(spinIntervalRef.current);
        }

        spinIntervalRef.current = setInterval(() => {
            spin(2);
        }, 6);
    }, [spin]);

    const restartAnimation = useCallback(() => {
        if (!doc.current?.ball) return;

        doc.current.ball.style.animation = "none";
        void doc.current.ball.offsetWidth;
        doc.current.ball.style.animation = null;
    }, []);

    const endroll = useCallback(() => {
        if (winTimeoutRef.current) {
            clearTimeout(winTimeoutRef.current);
        }

        winTimeoutRef.current = setTimeout(() => {
            setIsWin(true);
            winTimeoutRef.current = null;
        }, 2000);

        if (spinIntervalRef.current) {
            clearInterval(spinIntervalRef.current);
            spinIntervalRef.current = null;
        }

        if (rollingStopIntervalRef.current) {
            clearInterval(rollingStopIntervalRef.current);
        }

        rollingStopIntervalRef.current = setInterval(() => {
            if (position.current !== targetPositionRef.current) {
                spin(1);
            } else {
                if (endRollTimeoutRef.current) {
                    clearTimeout(endRollTimeoutRef.current);
                    endRollTimeoutRef.current = null;
                }

                speed.current = 0.4;

                if (doc.current?.ball) {
                    doc.current.ball.style.animationPlayState = "running";
                }

                clearInterval(rollingStopIntervalRef.current);
                rollingStopIntervalRef.current = null;
            }
        }, 1);
    }, [spin]);

    const start = useCallback(() => {
        const result = oldResult?.result ?? 0;

        playAudio("roulette/spin.mp3");
        setIsWin(false);
        speed.current = 2;

        if (speedDecreaseIntervalRef.current) {
            clearInterval(speedDecreaseIntervalRef.current);
        }

        speedDecreaseIntervalRef.current = setInterval(() => {
            if (speed.current > 0.4) {
                speed.current -= 0.1;
            } else {
                clearInterval(speedDecreaseIntervalRef.current);
                speedDecreaseIntervalRef.current = null;
            }
        }, 500);

        restartAnimation();

        targetPositionRef.current = rollerInfo[result] ?? 0;

        setIntSpin();

        if (endRollTimeoutRef.current) {
            clearTimeout(endRollTimeoutRef.current);
        }

        endRollTimeoutRef.current = setTimeout(() => {
            endroll();
        }, 6000);
    }, [oldResult, restartAnimation, setIntSpin, endroll]);

    useEffect(() => {
        return () => {
            clearSpinTimers();
        };
    }, [clearSpinTimers]);

    return {
        isWin,
        setIsWin,
        speed,
        doc,
        position,
        start,
        endroll,
        spin,
        setIntSpin,
        restartAnimation,
        clearSpinTimers,
    };
};